import { Injectable } from '@angular/core';

import * as Stomp from 'stompjs';
import * as SockJS from 'sockjs-client';

import 'rxjs/add/operator/toPromise';

import {Role} from '../Model/Role';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class WebSocketService {

  public personName = '';
  public role: Role;
  WSconnected = false;
  public stompClient;

  constructor() {}

  initializeWebSocketConnection(): Observable<any> {

    const ws = new SockJS('https://lunchserver.inthergroup.com/socket');
    console.log(ws)
    this.stompClient = Stomp.over(ws);
    const that = this;
    ws.onclose = function() {
      that.stompClient.disconnect();
      console.log('close');
      that.WSconnected = false;
    };
    return that.stompClient;
  };
}



// WEBPACK FOOTER //
// ./src/app/Services/webSocket.service.ts